import React from "react";
import { useI18n } from "../../i18n";

const STATS_IMAGE =
  "https://images.unsplash.com/photo-1622021142947-da7dedc7c39a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjaGVmJTIwcmVzdGF1cmFudCUyMGtpdGNoZW58ZW58MHx8fHwxNzc5MDA0ODQxfDA&ixlib=rb-4.1.0&q=85";

export default function WhyDigital() {
  const { t } = useI18n();
  const stats = [
    { v: t("why.s1_v"), l: t("why.s1_l") },
    { v: t("why.s2_v"), l: t("why.s2_l") },
    { v: t("why.s3_v"), l: t("why.s3_l") },
  ];

  return (
    <section id="why" className="section-y" data-testid="why-section">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="relative rounded-[24px] overflow-hidden border border-brand-line reveal">
              <img
                src={STATS_IMAGE}
                alt="Chef plating a dish in a professional kitchen"
                className="w-full h-[420px] md:h-[520px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-brand-ink/70 to-transparent">
                <p className="font-serif text-2xl text-brand-ivory leading-snug max-w-xs">
                  "Your guests are looking — make sure they find you."
                </p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-7">
            <p className="eyebrow reveal">{t("why.eyebrow")}</p>
            <h2 className="display-h2 mt-4 text-brand-ink reveal" data-delay="1" data-testid="why-title">
              {t("why.title")}
            </h2>
            <p className="body-lg mt-6 max-w-xl reveal" data-delay="2">
              {t("why.lead")}
            </p>

            <ul className="mt-12 space-y-8">
              {stats.map((s, i) => (
                <li
                  key={i}
                  className="reveal flex flex-col md:flex-row gap-4 md:gap-8 items-start border-t border-brand-line pt-8"
                  data-delay={i + 1}
                  data-testid={`why-stat-${i + 1}`}
                >
                  <div className="font-serif text-5xl md:text-6xl text-brand-forest leading-none tracking-tight min-w-[140px]">
                    {s.v}
                  </div>
                  <p className="body-lg max-w-md">{s.l}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
